<template>
	<div :class="'text-slate-500 border-b border-gray-300 p-2 py-3 px-5 grid grid-cols-' + slotNumber + ' gap-4 items-center text-left'">
		<!-- COL 1 -->
		<div :class="'flex flex-row items-center gap-5 col-span-' + slotNumber + ' lg:col-span-1'">
			<div class="flex flex-row justify-center items-center w-auto lg:w-full text-slate-700 flex-grow">
				<p class="mr-5 text-blue-400" v-if="slots.icon">
					<slot name="icon"></slot>
				</p>
				<div class="w-full flex flex-col">
					<p class="font-medium">
						<slot name="name"></slot>
					</p>
				</div>
			</div>
		</div>
		<!-- COLS -->
		<div v-if="slots.skills" class="text-gray-500 text-sm hidden lg:block">
			<slot name="skills"></slot>
		</div>
		<div v-if="slots.address" class="text-gray-500 text-sm hidden lg:block">
			<slot name="address"></slot>
		</div>
		<div v-if="slots.contact" class="text-gray-500 text-sm hidden lg:block">
			<slot name="contact"></slot>
		</div>
		<div v-if="slots.target" class="text-gray-500 text-sm hidden lg:block">
			<slot name="target"></slot>
		</div>
		<div v-if="slots.lastVisit" class="text-gray-500 text-sm hidden lg:block">
			<slot name="lastVisit"></slot>
		</div>
		<div v-if="slots.structures" class="flex flex-col gap-2 text-gray-500 text-sm hidden lg:flex">
			<slot name="structures"> </slot>
		</div>
		<div v-if="slots.faeNumber" class="text-gray-500 text-sm hidden lg:block">
			<slot name="faeNumber"></slot>
		</div>
		<div v-if="slots.faeDateEnd" class="text-gray-500 text-sm hidden lg:block">
			<slot name="faeDateEnd"></slot>
		</div>
		<div v-if="slots.faeDateStart" class="text-gray-500 text-sm hidden lg:block">
			<slot name="faeDateStart"></slot>
		</div>
		<div v-if="slots.type" class="text-gray-500 text-sm hidden lg:block">
			<slot name="type"></slot>
		</div>
		<div v-if="slots.status" class="text-gray-500 text-sm hidden lg:block">
			<slot name="status"></slot>
		</div>
	</div>
</template>

<script setup>
	import { useSlots, computed } from 'vue';

	const slots = useSlots();

	const props = defineProps({
		log: {
			type: Object,
			default: null,
		},
		displayBullet: {
			type: Boolean,
			default: true,
		},
	});

	const color = computed(() => {
		if (props.log) {
			return props.log.targetable.color;
		}
		return null;
	});

	const slotNumber = computed(() => {
		return Object.keys(slots).length - 1;
	});
</script>
